export default "__VITE_PUBLIC_ASSET__de250a99__"